import { render, staticRenderFns } from "./FormQuestionOpenEndedType.vue?vue&type=template&id=fbb86a22"
import script from "./FormQuestionOpenEndedType.vue?vue&type=script&lang=js"
export * from "./FormQuestionOpenEndedType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb86a22')) {
      api.createRecord('fbb86a22', component.options)
    } else {
      api.reload('fbb86a22', component.options)
    }
    module.hot.accept("./FormQuestionOpenEndedType.vue?vue&type=template&id=fbb86a22", function () {
      api.rerender('fbb86a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionOpenEndedType.vue"
export default component.exports